import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from '../pages/Home';
import Users from '../pages/Users';
import Settings from '../pages/Settings';

import DrAccount from '../pages/DrAccount';
import ClinicAccount from '../pages/ClinicAccount';
import DrAccountList from '../pages/DrAccountList';
import ClinicAccountList from '../pages/ClinicAccountList';
import Header from './Header';
import Sidebar from './Sidebar';
import { Box, CssBaseline, Toolbar } from '@mui/material';

const drawerWidth = 0; // サイドメニューの幅を300に設定

const Dashboard: React.FC = () => {
  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <Header />
      <Sidebar />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          marginLeft: `${drawerWidth}px`,
        }}
      >
        <Toolbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="users" element={<Users />} />
          <Route path="settings" element={<Settings />} />

          
          <Route path="clinic-account" element={<ClinicAccount />} />
          <Route path="clinic-account-list" element={<ClinicAccountList />} />
          <Route path="dr-account" element={<DrAccount />} />
          <Route path="dr-account-list" element={<DrAccountList />} />
        </Routes>
      </Box>
    </Box>
  );
};

export default Dashboard;
